


























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { BaseView } from './BaseView';

@Component<Footer>({
  props: {
    position: String,
  },
})
export default class Footer extends BaseView {
  public openCookieSettings() {
    const uc = (window as any).UC_UI;
    console.log(uc)
    if (uc) {
      uc.showSecondLayer();
    }
  }
}
